/**
 * 国优炬康 管理后台品牌 Store (Pinia)
 *
 * 启动时从公开端点拉取品牌配置(logo/主副标题/主题色),
 * 登录页同样可用;保存品牌设置后调用 apply 立即生效。
 */

import { defineStore } from 'pinia';
import { ref } from 'vue';

import instance from '@/utils/request';
import { applyThemeColor, DEFAULT_THEME_COLOR } from '@/utils/theme';

export const useBrandStore = defineStore('brand', () => {
  const logo = ref('');
  const mainTitle = ref('国优炬康');
  const subTitle = ref('慢病综合服务平台');
  const themeColor = ref(DEFAULT_THEME_COLOR);
  const loaded = ref(false);

  function apply(cfg: Partial<{ logo: string; mainTitle: string; subTitle: string; themeColor: string }> | null | undefined) {
    logo.value = cfg?.logo || '';
    mainTitle.value = cfg?.mainTitle?.trim() || '国优炬康';
    subTitle.value = cfg?.subTitle?.trim() || '慢病综合服务平台';
    themeColor.value = cfg?.themeColor || DEFAULT_THEME_COLOR;
    applyThemeColor(themeColor.value);
  }

  async function fetchBrand() {
    try {
      // 公开端点(与小程序同源),无需登录
      const res = await instance.get('/config/site-brand');
      apply(res);
    } catch {
      // 拉取失败保留默认品牌
    } finally {
      loaded.value = true;
    }
  }

  return { logo, mainTitle, subTitle, themeColor, loaded, apply, fetchBrand };
});
